import { render, staticRenderFns } from "./PdfImgViewer.vue?vue&type=template&id=8117983e&scoped=true"
import script from "./PdfImgViewer.vue?vue&type=script&lang=js"
export * from "./PdfImgViewer.vue?vue&type=script&lang=js"
import style0 from "./PdfImgViewer.vue?vue&type=style&index=0&id=8117983e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8117983e",
  null
  
)

export default component.exports